export default "__VITE_ASSET__D1u9g26h__"